const articleTypes = {
  ARTICLE_BIOGRAPHY: "ARTICLE_BIOGRAPHY",
  ARTICLE_DRAMA: "ARTICLE_DRAMA",
  ARTICLE_EDITORIAL: "ARTICLE_EDITORIAL",
  ARTICLE_FICTION: "ARTICLE_FICTION",
  ARTICLE_INFOGRAPHIC: "ARTICLE_INFOGRAPHIC",
  ARTICLE_INFORMATION: "ARTICLE_INFORMATION",
  ARTICLE_MAP: "ARTICLE_MAP",
  ARTICLE_PHOTO: "ARTICLE_PHOTO",
  ARTICLE_POEM: "ARTICLE_POEM",
  ARTICLE_NEWS: "ARTICLE_NEWS",
};

export type ArticleType = (typeof articleTypes)[keyof typeof articleTypes];

export default articleTypes;
